import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService
} from 'viggo-sistemas-core-web';
import { IDeposito } from '../models/deposito.model';

@Injectable()
export class DepositoService extends EntityService<IDeposito> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'deposito',
      pluralBaseEntityEndPoint: 'depositos'
    });
  }
}
